/** @jsx jsx */
import type { HTMLAttributes } from 'react';
import React from 'react';
import { jsx } from '@balance-web/core';
import { theme } from '@balance-web/theme';

export const Divider = (props: HTMLAttributes<HTMLDivElement>) => {
  const width = 1;

  return (
    <div
      css={{
        alignSelf: 'center',
        backgroundColor: theme.semantic.colour.primary.background,
        height: '100%',
        width,
      }}
      {...props}
    />
  );
};
Divider.displayName = 'RadioButtonGroupDivider';
